import { Slide } from "@jelly/lesson";
import config from "appConfig";

import theory from "../../theory";

const principle: Slide = {
  description:
    "For the real-time auralisation we need block-based convolution. In this example we show the Overlap-Add algorithm. Please watch the process and hover over the different elements, to understand the concept.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "video",
            options: {
              src: `${config.ASSETS_URL}/03/19/principle/slide-01.m4v`,
              controls: false,
              loop: true,
              autoplay: true,
              muted: true,
            },
          },
          styles: {
            padding: "0%",
          },
        },
      },
    },
  },
};

export default principle;
